function render( msrp?: number ) {
	return msrp ? new Intl.NumberFormat( 'en-US', {
		style: 'currency',
		currency: 'USD',
		maximumFractionDigits: 4,
		minimumFractionDigits: 2,
	} ).format( msrp ) : ''
}

export default {
	field: 'msrp',
	name: 'MSRP',
	width: '120px',
	render,
}
